import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppModal from "./AppModal";
import { loginPathForRole } from "../utils/loginPaths";
import { clearPortalStorage } from "../utils/api";

const SESSION_TIMEOUT_EVENT = "session-timeout-event";

const SessionTimeoutModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("Your session has expired. Please log in again.");
  const navigate = useNavigate();

  useEffect(() => {
    const handleSessionTimeout = (event) => {
      const nextMessage = String(
        event?.detail?.message || "Your session has expired. Please log in again."
      );
      setMessage(nextMessage);
      setIsOpen(true);
    };

    window.addEventListener(SESSION_TIMEOUT_EVENT, handleSessionTimeout);

    return () => {
      window.removeEventListener(SESSION_TIMEOUT_EVENT, handleSessionTimeout);
    };
  }, []);

  const goToLogin = () => {
    clearPortalStorage();
    setIsOpen(false);
    navigate(loginPathForRole(), { replace: true });
  };

  useEffect(() => {
    if (!isOpen) return;
    const timer = window.setTimeout(() => {
      clearPortalStorage();
      setIsOpen(false);
      navigate(loginPathForRole(), { replace: true });
    }, 2200);
    return () => window.clearTimeout(timer);
  }, [isOpen, navigate]);

  return (
    <AppModal
      open={isOpen}
      onClose={goToLogin}
      title="Session Timed Out"
      size="md"
      zIndex={99998}
      footer={(
        <button
          type="button"
          onClick={goToLogin}
          className="app-modal-btn-primary rounded-xl px-4 py-2 text-sm font-semibold transition"
        >
          Go to Login
        </button>
      )}
    >
      <p className="text-sm font-medium theme-heading">{message}</p>
    </AppModal>
  );
};

export default SessionTimeoutModal;
